export default __webpack_public_path__ + "static/iconfinder_21_3319623-0a82c98bf677e213f4e6b7efbcd694e0.png";